/**
 * useComplianceBadges — small hook that batches the per-job ack summary
 * fetch for any surface that needs the red/green shield badge (Jobs table,
 * calendars, dispatch, operative schedule).
 *
 * The hook is intentionally dumb: pass it the job ids you want to badge,
 * get back a map keyed by job id with `{linked, unacked, blocked}`.
 * Refetches whenever the id list changes (cheap signature compare avoids
 * loops when a parent re-renders with a stable array). Silent on failure
 * so the badge never blocks the underlying page.
 */
import { useEffect, useState } from "react";
import API from "../lib/api";

export default function useComplianceBadges(jobIds) {
  // Stable signature so an inline `[...jobs.map(j => j.id)]` array doesn't
  // refire the effect on every parent re-render.
  const signature = (jobIds || []).filter(Boolean).join(",");
  const [byJob, setByJob] = useState({});

  useEffect(() => {
    if (!signature) { setByJob({}); return undefined; }
    const ids = signature.split(",");
    let cancelled = false;
    API.post("/compliance-hub/jobs-ack-summary", { job_ids: ids })
      .then(({ data }) => { if (!cancelled) setByJob(data || {}); })
      .catch(() => { /* best-effort */ });
    return () => { cancelled = true; };
  }, [signature]);

  return byJob;
}
